import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class BackendApiService {
  constructor(private appConfig: AppConfigService, private http: HttpClient, private authenticationService: AuthenticationService) {
  }

  getText(url: string) {
    return this.http.get(this.appConfig.backendUrl + url, { responseType: 'text', headers: this.getAuthenticationHeader() });
  }

  authenticateDownload(containers: string[]) {
    return this.http.get(this.appConfig.containerDownloadUrl + 'authenticate/' + containers.join(','), { responseType: 'json', headers: this.getAuthenticationHeader() });
  }

  private getAuthenticationHeader() {
    return {
        'x-authorization': 'Bearer ' + this.authenticationService.getToken()
    };
  }
}
